import React from 'react'
import Skype from './Skype'
import Googlemeet from './Googlemeet'
import Whatsapp from './Whatsapp'
import Navbar from '../Components/Navbar'
import Languages from './Languages';
import Footer from '../Components/Footer'
export default function Onlineconsult() {
  return (
    <>
    <div><Navbar/></div>
    <div><Whatsapp/></div>
    <div><Skype/></div>

    <div><Googlemeet/></div>

    



    <div><Footer/></div>
    
    
    
    </>
  )
}
